import { UseQueryOptions } from 'react-query';
import { useAPI } from '@/services/utils';
import { useGetUserStatus } from '@/userStatus/hooks';

export const useGetTradeBalance = (
  reactQueryOptions?: UseQueryOptions<any>
) => {
  const { isVerified } = useGetUserStatus();

  return useAPI(['trade', 'getBalance'], {
    reactQueryOptions: {
      ...reactQueryOptions,
      enabled: isVerified,
    },
  });
};
